import {
  clearOdooSession,
  loadStoredOdooApiKey,
  loginToOdoo,
} from "@/api/odooAuthClient";
import { OdooStatementClient } from "@/api/odooStatementClient";

export const odooWebStorage = {
  async getItem(key) {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  async setItem(key, value) {
    localStorage.setItem(key, value);
  },
  async removeItem(key) {
    localStorage.removeItem(key);
  },
};

export async function restoreOdooClient() {
  const apiKey = await loadStoredOdooApiKey(odooWebStorage);
  if (!apiKey) return null;
  return new OdooStatementClient(apiKey);
}

export async function connectOdooPortal(credentials) {
  const session = await loginToOdoo(
    { ...credentials, device_name: credentials.device_name || "BOB website" },
    odooWebStorage,
  );
  return {
    session,
    client: new OdooStatementClient(session.api_key),
  };
}

export async function disconnectOdooPortal() {
  await clearOdooSession(odooWebStorage);
}
